import {
  RequestCounties,
  RequestInReviewsByCounty,
} from "../dtos/exchanges/in";
import Server from "./index";

export default class ExchangesInServer extends Server {
  constructor() {
    super("/exchanges_in.php");
  }

  public get(params: RequestCounties | RequestInReviewsByCounty): Promise<any> {
    return super.get(params);
  }
}
